import { Schedule, DaysOfTheWeek, MixedSchedule, RawSchedule } from '@mode/shared/schedules/contract';
import { StringHelpers } from '@mode/shared/util-js';

export const toMixedSchedule = (rawSchedule: RawSchedule): MixedSchedule => {
  rawSchedule['cleanSchedule'] = toCleanSchedule(rawSchedule);
  rawSchedule['isWeekday'] = isWeekdaySchedule(rawSchedule);
  if (rawSchedule['isWeekday']) {
    rawSchedule['cron'].freq = 'weekly';
    rawSchedule['frequencyText'] = rawSchedule['frequencyText']?.replace(
      'Monday,Tuesday,Wednesday,Thursday,Friday',
      'weekday'
    );
  }
  return rawSchedule as MixedSchedule;
};

const weekArray: DaysOfTheWeek[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const isWeekdaySchedule = (rawSchedule: RawSchedule) =>
  rawSchedule.frequency === 'weekly' && rawSchedule.day_of_week === 'Monday,Tuesday,Wednesday,Thursday,Friday';

const toCleanSchedule = (rawSchedule: RawSchedule): Schedule => {
  const isWeekday =
    rawSchedule['cron'].freq === 'weekly' && rawSchedule.day_of_week === 'Monday,Tuesday,Wednesday,Thursday,Friday';

  const frequency = isWeekday || rawSchedule['cron'].day_of_week === '1,2,3,4,5' ? 'weekday' : rawSchedule['cron'].freq;

  const dayOfTheWeek =
    rawSchedule['cron'].day_of_week === '1,2,3,4,5' ? 'Monday' : weekArray[rawSchedule['cron'].day_of_week];

  const dayOfMonth = StringHelpers.ordinal(rawSchedule['cron'].day_of_month);

  return {
    frequency,
    minute: rawSchedule['cron'].minute,
    hour: rawSchedule['cron'].hour,
    timeZone: rawSchedule['cron'].time_zone,
    dayOfTheWeek: dayOfTheWeek,
    dayOfMonth: dayOfMonth,
  };
};
